import { useTheme } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import DocLink from 'features/common/ui/utils/DocLink'
import { DOCS_SHARE_CONNECTION_VIEWER_CREDENTIALS } from 'app/constants/urls'
import { Alert, Typography } from '@carto/meridian-ds/components'
import { VpnKeyOutlined } from '@mui/icons-material'

export function ShareWithViewerCredentials() {
  const theme = useTheme()
  return (
    <Alert severity="neutral" icon={<VpnKeyOutlined htmlColor={theme.palette.text.hint} />}>
      <Typography variant="caption">
        <FormattedMessage
          id="connections.shareDialog.requiresViewerCredential.hint"
          values={{
            docLink: (content) => (
              <DocLink docUrl={DOCS_SHARE_CONNECTION_VIEWER_CREDENTIALS} showExternalIcon={false}>
                {content}
              </DocLink>
            )
          }}
        />
      </Typography>
    </Alert>
  )
}

export default ShareWithViewerCredentials
